import i18n from "@/domain/utils/i18n";

/**
 * Función helper para manejar traducciones con fallback
 * @param key Clave de traducción en el JSON
 * @param defaultText Texto por defecto si la clave no existe
 * @returns Traducción o el texto por defecto
 */
export const translate = (key: string, lng?: string, defaultText:string = 'Missing Text') => {
  return i18n.t(key, { defaultValue: defaultText, lng: lng || i18n.language });
};
